import {useMutation, useQueryClient} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {message} from "antd";
import {DeliverWorkInput} from "../domain/product-service.types";
import {createProductServiceRepository} from "../data/repositories";
import {
  GET_STORE_SERVICE_ORDER_RQ_KEY,
  GET_STORE_SERVICES_ORDERS_RQ_KEY,
} from "../../../react-query-hooks/store/services/constants";

/**
 * Marks an order as delivered (submits work). On settle, invalidates the
 * in-progress orders list and the order detail so the drawer refreshes.
 *
 * The v2 delivery response returns only the created delivery (no order object),
 * so consumers should rely on this invalidation (not the response) to refresh.
 */
export const useDeliverWork = () => {
  const queryClient = useQueryClient();
  const repository = createProductServiceRepository();

  return useMutation<void, AxiosError<{message: string}>, DeliverWorkInput>({
    mutationFn: (input) => repository.deliverWork(input),
    onError: (error: AxiosError<{message: string}>) => {
      if (error.message) {
        message.error(error.message);
      }
    },
    onSettled: (_data, _error, input) =>
      Promise.all([
        queryClient.invalidateQueries({
          queryKey: [GET_STORE_SERVICES_ORDERS_RQ_KEY, {statusId: 4, page: 1}],
        }),
        queryClient.invalidateQueries({
          queryKey: [GET_STORE_SERVICE_ORDER_RQ_KEY, String(input.transactionId)],
        }),
      ]),
  });
};
